// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TxiYX","content":"styles_content__2HCMf"};